import React from "react";

const MessageBox = ({ message, onClose, onConfirm, type }) => {
  const getTypeStyles = () => {
    switch (type) {
      case "success":
        return "bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100";
      case "error":
        return "bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100";
      case "warning":
        return "bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100";
      default:
        return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100";
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl p-6 max-w-md w-full dark:bg-gray-900 transform transition-all scale-95 hover:scale-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`flex items-center justify-center rounded-lg py-2 mb-4 ${getTypeStyles()} transition-all`}
        >
          <h2 className="font-semibold text-lg">Thông báo</h2>
        </div>
        <p className="text-sm">{message}</p>
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-6 py-2 rounded-full hover:bg-gray-400 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-all"
          >
            Đóng
          </button>
          <button
            onClick={onConfirm}
            className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageBox;
